import { action, makeObservable, observable } from 'mobx';

export type AlertState = 'info' | 'error';

export interface IGlobalAlertStore {
	readonly title: string | null;
	readonly message: string | null;
	info: (message: string, title?: string) => void;
	error: (message: string, title?: string) => void;
	clearState: () => void;
	state: AlertState;
}

export default class GlobalAlertStore {
	public title: string | null = null;
	public message: string | null = null;
	public state: AlertState = 'info';

	constructor() {
		makeObservable(this, {
			title: observable.struct,
			message: observable.struct,
			info: action.bound,
			error: action.bound,
			clearState: action.bound
		});
	}

	public info(message: string, title?: string): void {
		this.setState(message, title || localize('Information'), 'info');
	}

	public error(message: string, title?: string): void {
		this.setState(message, title || localize('Error'), 'error');
	}

	public clearState(): void {
		this.setState(null, null, 'info');
	}

	private setState(message: string | null, title: string | null, state: AlertState): void {
		this.title = title;
		this.message = message;
		this.state = state;
	}
}
